<template>
    <section id="checkout-thanks-header" class="mt-3">
        <div class="row">
            <div class="col-12">
                <h3>{{$t('co.final.title')}}</h3>
            </div>
        </div>
        <div class="row" v-if="isLoading">
            <div class="col-12 col-md-6 mt-3">
                <b-skeleton height="200px" class="w-100"></b-skeleton>
            </div>
            <div class="col-12 col-lg-4 mt-3" v-if="isLoading">
                <b-skeleton class="mb-1" height="1rem" width="50%"></b-skeleton>
                <b-skeleton class="mb-1" height="1rem" width="40%"></b-skeleton>
                <b-skeleton class="mb-1" height="1rem" width="55%"></b-skeleton>
                <b-skeleton class="mb-1 mt-3" height="1rem" width="45%"></b-skeleton>
                <b-skeleton class="mb-1" height="1rem" width="65%"></b-skeleton>
                <b-skeleton class="mb-1 mt-4" height="1rem" width="55%"></b-skeleton>
                <b-skeleton class="mb-1" height="1rem" width="100%"></b-skeleton>
                <b-skeleton class="mb-1" height="1rem" width="100%"></b-skeleton>
                <b-skeleton type="button" class="mt-3 mb-1" height="38px" width="100%"></b-skeleton>
            </div>
        </div>
        <div class="row" v-if="!isLoading">
            <div class="col-12 col-lg-6 mt-3">
                <b-img
                    :src="getImage"
                    :alt="getTitle"
                    fluid
                ></b-img>
            </div>
            <div class="col-12 col-md-4" v-if="!isLoading">
                <div class="title-box">
                    <p class="font-weight-bold">{{ getTitle }}</p>
                    <p>{{ getDescription }}</p>
                    <p>{{ getAvailabilityText }}</p>
                    <p v-if="getType == 'MVS'" >
                        <b-badge class="image-badge" :variant="'secondary'">{{ subscription.tier_title }}</b-badge>
                    </p>
                </div>
                <div class="subscription-data mt-3">
                    <p>{{ getMileage }} {{$t('co.final.overview.per_month')}}</p>
                    <p v-if="getDuration">{{ getDuration }} {{$t('co.final.overview.duration')}}</p>
                </div>
                <div class="payment-data mt-3">
                    <b>{{$t('co.final.overview.costs.title')}}</b>
                    <ul class="list-unstyled">
                        <li class="d-flex justify-content-between">
                            <span>
                                <font-awesome-icon :icon="['fas', 'check']" />
                                <span v-if="withoutTax">{{$t('co.final.overview.costs.all_inclusive_price')}}</span>
                                <span v-else>{{$t('co.final.overview.costs.all_inclusive_price')}}</span>
                            </span>
                            <span>{{ getPrice }}</span>
                        </li>
                        <li class="d-flex justify-content-between" v-if="!willBePickedUp">
                            <span>
                                <font-awesome-icon :icon="['fas', 'check']" />
                                {{$t('co.final.overview.costs.delivery')}}
                            </span>
                            <span>{{ getDeliveryCosts }}</span>
                        </li>
                    </ul>
                </div>
                <b-link class="btn btn-primary btn-block"
                    :to="$getUrl('cdb-dashboard')"
                >
                    {{$t('co.final.overview.button.cdb')}}
                </b-link>
            </div>
        </div>
    </section>
</template>

<script>
import CheckoutLayout from '../../layouts/CheckoutLayout.vue'
import { BLink, BImg, BSkeleton, BBadge} from 'bootstrap-vue';
import { gb } from "../../growthbook";
export default {
    name: 'CheckoutThanksHeader',
    components: {
        CheckoutLayout,
        BLink, BImg, BSkeleton, BBadge
    },
    props: {
      isLoading: true,
      subscription: null,
      entry: null
    },
    computed: {
        withoutTax() {
            return this.$root.whitelabel.setting('show_price_without_taxes')
        },
        getImage() {
            return this.entry ? this.entry.title_image : ''
        },
        getTitle() {
            return this.entry ? `${this.entry.title}` : ''
        },
        getDescription() {
            return this.entry ? this.entry.description : ''
        },
        getAvailabilityText() {
            if (this.entry) {
                if(gb.isOn("vehicle_availibility_updated")) {
                    return this.$t('vehicle.availability.text.' + this.entry.available_text)
                } else {
                    return this.entry.available_weeks === 1 ? `${this.$t('general.availability.week', {number: this.entry.available_weeks})}` : `${this.$t('general.availability.weeks', {number: this.entry.available_weeks})}`
                }
            }
        },
        getMileage() {
            return this.entry ? `${this.subscription.price_plan.mileage} ${this.$root.whitelabel.getMileageUnit()}` : ''
        },
        getType() {
            return this.entry ? `${this.subscription.type}` : ''
        },
        getDuration() {
            if (this.entry) {
                const entry = this.entry.price_plans.find(p => p.duration_id === parseInt(this.subscription.price_plan.duration))
                return entry ? entry.minimum_duration : ''
            }

            return ''
        },
        getPrice() {
            if (this.subscription) {
                let apCosts = 0
                if (this.subscription.additional_driver) {
                    apCosts += this.withoutTax
                        ? this.subscription.additional_driver_article.price_net
                        : this.subscription.additional_driver_article.price
                }
                if (this.subscription.dp_reduction) {
                    apCosts += this.withoutTax
                        ? this.subscription.dp_reduction_article.price_net
                        : this.subscription.dp_reduction_article.price
                }

                const price = this.withoutTax ? this.subscription.price_plan.price_without_tax : this.subscription.price_plan.price;
                return this.subscription ? `${this.$root.whitelabel.getFormatetPrice(price + apCosts)}` : ''
            }

            return ''
        },
        getDeliveryCosts() {
            if (this.subscription) {
                const price = this.withoutTax ? this.subscription.delivery.deliveryCosts_net : this.subscription.delivery.deliveryCosts
                return this.subscription ? `${this.$root.whitelabel.getFormatetPrice(price)}` : ''
            }

            return ''
        },
        willBePickedUp() {
            return this.subscription && this.subscription.delivery.deliveryMethod === 'pickup'
        }
    }
}
</script>
